import SalaryGraph from './SalaryGraph'
export default SalaryGraph
